import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { Field, change, reduxForm } from 'redux-form';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import TextInput from '../../../common/forms/input/TextInput';
import Select from '../../../common/forms/select/Select';
import { enumToSelectOptions } from '../../../../utils/enum';
import {
  MAINTENANCE_WARNING_TYPE,
  MAINTENANCE_WARNING_PRIORITY,
  MAINTENANCE_WARNING_RECURRENCE,
} from '../../../../config/constants';
import MaintenanceFailModeSelect from '../../../common/forms/select/MaintenanceFailModeSelect';

export const MAINTENANCE_CHECKLIST_ADDITIONAL_ACTIVITY_FORM_NAME =
  'MaintenanceChecklistAdditionalActivityForm';

export const MaintenanceChecklistAdditionalActivityForm = ({
  handleSubmit,
  loading,
  dispatchChange,
  requiredField,
  showFooter,
}) => {
  const [failModeCategoryOptions, setFailModeCategoryOptions] = React.useState(
    [],
  );

  const clearFailModeDependentFields = () => {
    dispatchChange(
      MAINTENANCE_CHECKLIST_ADDITIONAL_ACTIVITY_FORM_NAME,
      'priority',
      null,
    );

    dispatchChange(
      MAINTENANCE_CHECKLIST_ADDITIONAL_ACTIVITY_FORM_NAME,
      'maintenanceFailModeCategoryId',
      null,
    );

    setFailModeCategoryOptions([]);
  };

  const onChangeFailMode = (option) => {
    if (!option) {
      clearFailModeDependentFields();
      return;
    }

    dispatchChange(
      MAINTENANCE_CHECKLIST_ADDITIONAL_ACTIVITY_FORM_NAME,
      'priority',
      option.priority ? MAINTENANCE_WARNING_PRIORITY[option.priority] : null,
    );

    dispatchChange(
      MAINTENANCE_CHECKLIST_ADDITIONAL_ACTIVITY_FORM_NAME,
      'maintenanceFailModeCategoryId',
      null,
    );

    const categoryList = option.maintenanceFailModeCategoryList || [];

    if (!categoryList.length) {
      setFailModeCategoryOptions([]);
    } else {
      const categoryOptions = categoryList.map((category) => ({
        value: category.id,
        label: category.name,
        raw: category,
      }));

      setFailModeCategoryOptions(categoryOptions);

      if (categoryOptions.length === 1) {
        dispatchChange(
          MAINTENANCE_CHECKLIST_ADDITIONAL_ACTIVITY_FORM_NAME,
          'maintenanceFailModeCategoryId',
          categoryOptions[0],
        );
      }
    }
  };

  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Tipo de Ocurrencia" required={requiredField}>
          <Field
            name="maintenanceWarningType"
            component={Select}
            options={enumToSelectOptions(MAINTENANCE_WARNING_TYPE)}
            validate={requiredField ? [isRequired] : null}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Modo Falla" required={requiredField}>
          <Field
            name="maintenanceFailModeId"
            component={MaintenanceFailModeSelect}
            onChange={onChangeFailMode}
            validate={requiredField ? [isRequired] : null}
            isClearable
          />
        </FormItem>
      </FormGroup>

      {failModeCategoryOptions.length ? (
        <FormGroup row>
          <FormItem label="Categoría" required={requiredField}>
            <Field
              name="maintenanceFailModeCategoryId"
              component={Select}
              options={failModeCategoryOptions}
              validate={requiredField ? [isRequired] : null}
              isClearable={failModeCategoryOptions.length > 1}
              isDisabled={failModeCategoryOptions.length === 1}
            />
          </FormItem>
        </FormGroup>
      ) : null}

      <FormGroup row>
        <FormItem label="Prioridad" required={requiredField}>
          <Field
            name="priority"
            component={Select}
            options={enumToSelectOptions(MAINTENANCE_WARNING_PRIORITY)}
            validate={requiredField ? [isRequired] : null}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Reincidencia">
          <Field
            name="recurrence"
            component={Select}
            options={MAINTENANCE_WARNING_RECURRENCE}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Comentario">
          <Field
            name="comments"
            component={TextInput}
            type="textarea"
            maxLength={200}
          />
        </FormItem>
      </FormGroup>

      {showFooter && <FormFooter />}
    </Form>
  );
};

MaintenanceChecklistAdditionalActivityForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchChange: PropTypes.func.isRequired,
  requiredField: PropTypes.bool,
  showFooter: PropTypes.bool,
};

MaintenanceChecklistAdditionalActivityForm.defaultProps = {
  requiredField: true,
  showFooter: true,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  loading: !MechanicalMaintenanceUnit.MaintenanceWarning.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchChange: change,
};

const formComponent = reduxForm({
  form: MAINTENANCE_CHECKLIST_ADDITIONAL_ACTIVITY_FORM_NAME,
})(MaintenanceChecklistAdditionalActivityForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
